import * as ko from "knockout";
import PromiseRequest from "../../../req/PromiseRequest";
import {IFormData} from "./index";
import {ErrorTracker} from "../../../error.tracker";
import {PLEASE_WAIT_MESSAGE} from "../../../constants/Language";
import {createErrorMessage} from "../../../util/misc";
import {config} from "../../../appContext";
import method_smsHtml from './method-sms.html?raw';

export let template = method_smsHtml;

export class viewModel {

    private grecaptchaId!: number;
    private readonly captchacode: KnockoutObservable<string | null> = ko.observable(null);
    private readonly reqForgotPassword = new PromiseRequest("forgotpassword");
    private et: ErrorTracker;

    constructor(private params: IFormData) {
        this.et = params.et;
        this.initReCaptcha();
    }

    private initReCaptcha() {
        this.grecaptchaId = grecaptcha.render('fprc', {
            sitekey: config.RECAPTCHA_SITE_KEY,
            callback: this.onCaptchaResponse.bind(this)
        });
    }

    private resetReCaptcha() {
        grecaptcha.reset(this.grecaptchaId);
    }

    protected isFormValid = ko.pureComputed((): boolean => {
        const a = this.params.username().length >= 2;
        this.et.update(!a, this.params.username, 'username too short');
        const b = !!this.params.ssn().length;
        this.et.update(!b, this.params.ssn, 'invalid social security number or employee number');
        const c = this.params.mobile().length >= 8;
        this.et.update(!c, this.params.mobile, 'invalid mobile number');
        const d = !!this.captchacode();
        return a && b && c && d;
    });

    protected onSubmit() {
        if (this.isFormValid()) {
            this.params.isReady(false);
            this.params.messageData({message: PLEASE_WAIT_MESSAGE});
            this.reqForgotPassword.abort();
            const params = {
                captchacode: this.captchacode(),
                mobile: this.params.mobile(),
                nin: this.params.ssn(),
                orgnr: this.params.selectedOrg().orgnr,
                username: this.params.username(),
            };
            this.reqForgotPassword
                .request(params)
                .then(() => {
                    this.params.messageData({
                        message: `password.forgot sms success`,
                    });
                })
                .catch((reason: string) => {
                    this.params.messageData(createErrorMessage(String(reason)));
                    this.captchacode(null);
                    this.resetReCaptcha();
                    this.params.isReady(true);
                });
        }
    }

    private onCaptchaResponse(resp: string) {
        this.captchacode(resp);
    }

    dispose() {
        this.resetReCaptcha();
    }

}